export const representativeCommand = {
  sendRegistrationKey: 'sendRegistrationKeyRepresentative',
  copyCodeToClipboard: 'copyCodeToClipboard',
  editRepresentative: 'editRepresentative',
  deleteRepresentative: 'deleteRepresentative',
};
